import moment from 'moment';
import { pickingDateVsSaleDateToReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const pickingDateVsSaleDate = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Fecha_Picking_vs_Fecha_de_Venta.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'ID.',
        name: 'id',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w130',
        value: (element: pickingDateVsSaleDateToReport) => element.id
      },
      {
        title: 'Id de envío',
        name: 'dispatchId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickingDateVsSaleDateToReport) => element.dispatchId
      },
      {
        title: 'Compañía',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickingDateVsSaleDateToReport) => element.companyCode
      },
      {
        title: 'Nombre de tipo de entrega',
        name: 'deliveryTypeName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: pickingDateVsSaleDateToReport) => element.deliveryTypeName
      },
      {
        title: 'Tipo de origen',
        name: 'originType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickingDateVsSaleDateToReport) => element.originType
      },
      {
        title: 'Retraso picking descripción',
        name: 'delayPickingConsolidatedDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: pickingDateVsSaleDateToReport) => element.delayPickingConsolidatedDescription
      },
      {
        title: 'Canal',
        name: 'channel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w120',
        value: (element: pickingDateVsSaleDateToReport) => element.channel
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w120',
        value: (element: pickingDateVsSaleDateToReport) => moment(element.deliveryDate).format('YYYY-MM-DD')
      },
      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w120',
        value: (element: pickingDateVsSaleDateToReport) => element.total
      }
    ],
    subTable: {}
  };
